import { render } from "./ConversationView.vue?vue&type=template&id=5270b03e&scoped=true"
import script from "./ConversationView.vue?vue&type=script&lang=js"
export * from "./ConversationView.vue?vue&type=script&lang=js"

import "./ConversationView.vue?vue&type=style&index=0&id=5270b03e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5270b03e"]])

export default __exports__